// -- helper functions --
export const formatGreeting = (firstName: string) =>
  firstName ? `Hi, ${firstName}!` : 'Hi!';

export const capitalize = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

// TODO-TS: type this properly
export function transformTaxonomy(taxonomy: any) {
  const taxonomyObject = {};
  const taxonomyArray = Array.isArray(taxonomy) ? taxonomy : [];

  taxonomyArray.forEach((taxonomyEl) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore see above
    taxonomyObject[taxonomyEl.nwVarName] = taxonomyEl.value;
  });

  return taxonomyObject;
}

const DEVICE_TYPES = ['android', 'iphone', 'ipad'];

export const isDevice = (type: string) => {
  if (!DEVICE_TYPES.includes(type)) {
    throw new Error(`Unrecognized device: ${type}`);
  }

  return (
    typeof window !== 'undefined' &&
    window?.navigator?.userAgent?.toLowerCase()?.includes(type)
  );
};

// TODO-TS: type this properly
export const getInitialState = (props: any) =>
  // The experiments reducer comes from nw-client-lib which expects the experiments to be set in initial state
  props.experiments ? { experiments: props.experiments } : {};
